export const lookThroughDepthOptions = [
    {"label": "Level 1", "value": 1},
    {"label": "Level 2", "value": 2},
    {"label": "Level 3", "value": 3},
    {"label": "Level 4", "value": 4},
    {"label": "Level 5", "value": 5},
  ];

export function getLookThroughDepthOptionLabel(value: number) {
  const lookThroughOption = lookThroughDepthOptions.find((option) => option.value === value);

  if (lookThroughOption) {
    return lookThroughOption.label;
  }

  return '-';
}